import React from 'react'
import { Icon } from '../../../../../atoms/Icon'
import { InfoTooltip } from '../../../../../InfoTooltip'
import { TooltipMetricExplanation } from '../../../../../TooltipMetricExplanation'
import {
  Card,
  CardHeader,
  CardTitle,
  MetricGrid,
  MetricRow,
  MetricLabel,
  MetricValue,
  MetricHighlight,
} from '../../../BuildingCharacteristics.styles'
import type { AgeAnalysisCardProps } from '../ConstructionTimelineTab.types'

export const AgeAnalysisCard: React.FC<AgeAnalysisCardProps> = ({
  buildingYear,
  buildingAge,
  isAgeEstimate,
  buildingPeriod,
  ageCategory,
  t,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <Icon name="calendar" size="small" />
          {t('timeline.cards.ageAnalysis.title')}
        </CardTitle>
      </CardHeader>
      <MetricGrid>
        <MetricRow>
          <MetricLabel>
            {t('timeline.labels.constructionYear')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'overview.cards.status.tooltips.constructionYear.title'
                )}
                shortDescription={t(
                  'overview.cards.status.tooltips.constructionYear.description'
                )}
                calculation={t(
                  'overview.cards.status.tooltips.constructionYear.calculation'
                )}
                importance={t(
                  'timeline.cards.ageAnalysis.tooltips.constructionYear.importance'
                )}
                source={t(
                  'timeline.cards.ageAnalysis.tooltips.constructionYear.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {buildingYear > 0 ? (
              <>
                {buildingYear}
                {isAgeEstimate && (
                  <span style={{ fontSize: '12px', opacity: 0.7 }}>
                    {' '}
                    (
                    {t('overview.values.estimatedFrom', {
                      source: buildingPeriod,
                    })}
                    )
                  </span>
                )}
              </>
            ) : (
              t('common.na')
            )}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('timeline.labels.buildingAge')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'timeline.cards.ageAnalysis.tooltips.buildingAge.title'
                )}
                shortDescription={t(
                  'timeline.cards.ageAnalysis.tooltips.buildingAge.description'
                )}
                calculation={t(
                  'timeline.cards.ageAnalysis.tooltips.buildingAge.calculation'
                )}
                importance={t(
                  'timeline.cards.ageAnalysis.tooltips.buildingAge.importance'
                )}
                source={t(
                  'timeline.cards.ageAnalysis.tooltips.buildingAge.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricValue>
            {buildingAge > 0 ? (
              <>
                {buildingAge} {t('common.years')}
                {isAgeEstimate && (
                  <span style={{ fontSize: '12px', opacity: 0.7 }}>
                    {' '}
                    ({t('overview.labels.estimated')})
                  </span>
                )}
              </>
            ) : (
              t('common.na')
            )}
          </MetricValue>
        </MetricRow>
        <MetricRow>
          <MetricLabel>
            {t('timeline.labels.ageCategory')}
            <InfoTooltip>
              <TooltipMetricExplanation
                title={t(
                  'timeline.cards.ageAnalysis.tooltips.ageCategory.title'
                )}
                shortDescription={t(
                  'timeline.cards.ageAnalysis.tooltips.ageCategory.description'
                )}
                categories={[
                  {
                    label: t('overview.ageCategories.new.label'),
                    range: t('overview.ageCategories.new.range'),
                    description: t('overview.ageCategories.new.description'),
                  },
                  {
                    label: t('overview.ageCategories.contemporary.label'),
                    range: t('overview.ageCategories.contemporary.range'),
                    description: t(
                      'overview.ageCategories.contemporary.description'
                    ),
                  },
                  {
                    label: t('overview.ageCategories.mature.label'),
                    range: t('overview.ageCategories.mature.range'),
                    description: t('overview.ageCategories.mature.description'),
                  },
                  {
                    label: t('overview.ageCategories.historic.label'),
                    range: t('overview.ageCategories.historic.range'),
                    description: t(
                      'overview.ageCategories.historic.description'
                    ),
                  },
                ]}
                importance={t(
                  'timeline.cards.ageAnalysis.tooltips.ageCategory.importance'
                )}
                source={t(
                  'timeline.cards.ageAnalysis.tooltips.ageCategory.source'
                )}
              />
            </InfoTooltip>
          </MetricLabel>
          <MetricHighlight $type={ageCategory.type}>
            {ageCategory.label}
          </MetricHighlight>
        </MetricRow>
        {buildingPeriod && (
          <MetricRow>
            <MetricLabel>
              {t('timeline.labels.buildingPeriod')}
              <InfoTooltip>
                <TooltipMetricExplanation
                  title={t(
                    'timeline.cards.ageAnalysis.tooltips.buildingPeriod.title'
                  )}
                  shortDescription={t(
                    'timeline.cards.ageAnalysis.tooltips.buildingPeriod.description'
                  )}
                  calculation={t(
                    'timeline.cards.ageAnalysis.tooltips.buildingPeriod.calculation'
                  )}
                  importance={t(
                    'timeline.cards.ageAnalysis.tooltips.buildingPeriod.importance'
                  )}
                  source={t(
                    'timeline.cards.ageAnalysis.tooltips.constructionPeriod.source'
                  )}
                />
              </InfoTooltip>
            </MetricLabel>
            <MetricValue>{buildingPeriod}</MetricValue>
          </MetricRow>
        )}
      </MetricGrid>
    </Card>
  )
}
